(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[170],{

/***/ 53963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_hub_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./styles/generic.module.scss
var generic_module = __webpack_require__(64256);
// EXTERNAL MODULE: ./components/business-footer/business-footer.tsx + 1 modules
var business_footer = __webpack_require__(41519);
// EXTERNAL MODULE: ./components/business-button/business-button.tsx
var business_button = __webpack_require__(52955);
// EXTERNAL MODULE: ./components/business-hub-footer/business-hub-footer-bottom.module.scss
var business_hub_footer_bottom_module = __webpack_require__(20548);
var business_hub_footer_bottom_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_footer_bottom_module);
;// CONCATENATED MODULE: ./components/business-hub-footer/business-hub-footer-bottom.tsx




const BusinessHubFooterBottom = (param)=>{
    let { ctaLink , page  } = param;
    const text = "Ready to grow your business?";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_footer_bottom_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_footer_bottom_module_default()).background,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "2302",
                    height: "2074",
                    viewBox: "0 0 2302 2074",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Vector",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                id: "path-1-inside-1_57_20",
                                fill: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M2140.35 418.559L1820.28 232.605L1495.58 43.8324C1280.97 -81.0766 1012.7 75.7639 1012.7 327.46V369.723C1012.7 393.202 1024.73 414.803 1045.08 426.073L1195.87 513.415C1237.49 537.834 1289.3 506.841 1289.3 458.005V357.514C1289.3 307.738 1342.02 276.745 1384.58 301.164L1680.59 473.97L1975.69 645.838C2018.24 670.256 2018.24 733.18 1975.69 757.598L1680.59 929.466L1384.58 1102.27C1342.02 1126.69 1289.3 1095.7 1289.3 1045.92V996.146C1289.3 744.45 1021.03 586.67 806.418 712.518L481.722 901.291L161.653 1087.25C-53.8845 1213.09 -53.8845 1529.59 161.653 1655.44L481.722 1841.4L806.418 2030.17C1021.03 2155.08 1289.3 1998.24 1289.3 1746.54V1704.28C1289.3 1680.8 1277.27 1659.2 1256.92 1647.93L1106.13 1560.59C1064.51 1536.17 1012.7 1567.16 1012.7 1616V1716.49C1012.7 1766.26 959.977 1797.25 917.424 1772.84L621.407 1600.03L326.314 1428.16C283.761 1403.74 283.761 1340.82 326.314 1316.4L621.407 1144.53L917.424 971.728C959.977 947.31 1012.7 978.302 1012.7 1028.08V1077.85C1012.7 1329.55 1280.97 1487.33 1495.58 1361.48L1820.28 1172.71L2140.35 986.755C2355.88 859.967 2355.88 544.408 2140.35 418.559Z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M2140.35 418.559L1820.28 232.605L1495.58 43.8324C1280.97 -81.0766 1012.7 75.7639 1012.7 327.46V369.723C1012.7 393.202 1024.73 414.803 1045.08 426.073L1195.87 513.415C1237.49 537.834 1289.3 506.841 1289.3 458.005V357.514C1289.3 307.738 1342.02 276.745 1384.58 301.164L1680.59 473.97L1975.69 645.838C2018.24 670.256 2018.24 733.18 1975.69 757.598L1680.59 929.466L1384.58 1102.27C1342.02 1126.69 1289.3 1095.7 1289.3 1045.92V996.146C1289.3 744.45 1021.03 586.67 806.418 712.518L481.722 901.291L161.653 1087.25C-53.8845 1213.09 -53.8845 1529.59 161.653 1655.44L481.722 1841.4L806.418 2030.17C1021.03 2155.08 1289.3 1998.24 1289.3 1746.54V1704.28C1289.3 1680.8 1277.27 1659.2 1256.92 1647.93L1106.13 1560.59C1064.51 1536.17 1012.7 1567.16 1012.7 1616V1716.49C1012.7 1766.26 959.977 1797.25 917.424 1772.84L621.407 1600.03L326.314 1428.16C283.761 1403.74 283.761 1340.82 326.314 1316.4L621.407 1144.53L917.424 971.728C959.977 947.31 1012.7 978.302 1012.7 1028.08V1077.85C1012.7 1329.55 1280.97 1487.33 1495.58 1361.48L1820.28 1172.71L2140.35 986.755C2355.88 859.967 2355.88 544.408 2140.35 418.559Z",
                                stroke: "#B2FCE4",
                                strokeWidth: "4",
                                mask: "url(#path-1-inside-1_57_20)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_hub_footer_bottom_module_default()).title),
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                link: ctaLink,
                className: (business_hub_footer_bottom_module_default()).button,
                buttonText: "Get started today",
                target: "_blank"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./components/business-hub-footer/business-hub-footer-contact-us/business-hub-footer-contact-us.module.scss
var business_hub_footer_contact_us_module = __webpack_require__(63745);
var business_hub_footer_contact_us_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_footer_contact_us_module);
;// CONCATENATED MODULE: ./components/business-hub-footer/business-hub-footer-contact-us/business-hub-footer-contact-us.tsx





const BusinessHubFooterContactUs = (props)=>{
    const { rounded  } = props;
    const [isShowMessage, setIsShowMessage] = (0,react.useState)(false);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const handleOnSuccess = ()=>{
        setIsShowMessage(true);
    };
    (0,react.useEffect)(()=>{
        if (!inView) {
            return;
        }
        const MktoForms2 = window.MktoForms2;
        const loadMarketoForm = ()=>{
            const newScriptElement = document.createElement("script");
            newScriptElement.onload = ()=>{
                triggerMarketoForm();
            };
            newScriptElement.setAttribute("src", "https://www.workwithsquare.com/js/forms2/js/forms2.min.js");
            document.body.appendChild(newScriptElement);
        };
        const triggerMarketoForm = ()=>{
            var ref;
            if (!window.MktoForms2) {
                return;
            }
            (ref = window.MktoForms2) === null || ref === void 0 ? void 0 : ref.loadForm("//www.workwithsquare.com", "424-IAB-218", 11166, function(form) {
                form.onSuccess(function() {
                    handleOnSuccess();
                    return false;
                });
            });
        };
        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "contact-us",
            className: (business_hub_footer_contact_us_module_default()).section,
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((business_hub_footer_contact_us_module_default()).background, {
                        [(business_hub_footer_contact_us_module_default()).rounded]: rounded
                    }),
                    children: " "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_footer_contact_us_module_default()).title,
                    children: "Contact us."
                }),
                isShowMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_footer_contact_us_module_default()).sectionAfterSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Thank you for your interest.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Our team will be in touch with you shortly."
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    id: "mktoForm_11166",
                    className: (business_hub_footer_contact_us_module_default()).sectionForm
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(48771);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/business-hub-footer/business-hub-footer-top.module.scss
var business_hub_footer_top_module = __webpack_require__(21302);
var business_hub_footer_top_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_footer_top_module);
;// CONCATENATED MODULE: ./components/business-hub-footer/business-hub-footer-top.tsx







const BusinessHubFooterTop = (props)=>{
    const { theme , ctaLink , page  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [endCap, setEndCap] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        switch(locale){
            case LangHelper/* Locale.GreatBritain */.go.GreatBritain:
                setEndCap("https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fb253e0e1fcae476a8d01f677ae08e7ee");
                break;
            case LangHelper/* Locale.NewZealand */.go.NewZealand:
            case LangHelper/* Locale.USA */.go.USA:
                setEndCap("https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F2b0bdaff206d46fa958563231183514a");
                break;
            default:
                setEndCap("https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F442c1a97e9594574b74bc8c4a92ecd42");
                break;
        }
    }, [
        locale
    ]);
    const title = (0,react.useMemo)(()=>{
        switch(locale){
            case LangHelper/* Locale.GreatBritain */.go.GreatBritain:
            case LangHelper/* Locale.USA */.go.USA:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_footer_top_module_default()).title,
                    children: [
                        "Say hello to\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: (business_hub_footer_top_module_default()).mobileBr
                        }),
                        "24 million",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "footer-asterisk"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "active global\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "customers today."
                    ]
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_footer_top_module_default()).title,
                    children: [
                        "Say hello to\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: (business_hub_footer_top_module_default()).mobileBr
                        }),
                        "4.4 million",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "footer-caret"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "active Afterpay\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "consumers today."
                    ]
                });
        }
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_hub_footer_top_module_default()).container, {
            [(business_hub_footer_top_module_default())["--light"]]: theme === "light"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_footer_top_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_footer_top_module_default()).left,
                    children: [
                        title,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_footer_top_module_default()).description,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "•"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Simple and easy sign up."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "•"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Easy integration."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "•"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Clear and transparent pricing."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            link: ctaLink,
                            className: (business_hub_footer_top_module_default()).button,
                            buttonText: "Get started",
                            target: "_blank"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_footer_top_module_default()).right,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_footer_top_module_default()).rightBox,
                        children: endCap ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: endCap,
                            alt: "",
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            },
                            fill: true,
                            loading: "eager",
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            },
                            sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                            className: (business_hub_footer_top_module_default()).image
                        }) : null
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/business-hub-footer/business-hub-footer.module.scss
var business_hub_footer_module = __webpack_require__(47790);
var business_hub_footer_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_footer_module);
;// CONCATENATED MODULE: ./components/business-hub-footer/business-hub-footer.tsx





const BusinessHubFooter = (param)=>{
    let { theme , footerLink , showContactUsForm , showSayHello =true , showReadyToGrow =true , page  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_footer_module_default()).container,
        children: [
            showSayHello ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubFooterTop, {
                theme: theme,
                ctaLink: footerLink,
                page: page
            }) : null,
            showContactUsForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubFooterContactUs, {
                rounded: !showReadyToGrow
            }) : null,
            showReadyToGrow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubFooterBottom, {
                ctaLink: footerLink,
                page: page
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/business-hub-footnotes/business-hub-footnotes.tsx
var business_hub_footnotes = __webpack_require__(59622);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(76899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(31882);
// EXTERNAL MODULE: ./components/business-hub-navigation/business-hub-menu-item.module.scss
var business_hub_menu_item_module = __webpack_require__(26401);
var business_hub_menu_item_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_menu_item_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75407);
;// CONCATENATED MODULE: ./components/business-hub-navigation/business-hub-menu-dropdown.tsx







const BusinessHubMenuDropdown = (props, ref)=>{
    const { items , popperStyles , attributes  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const route = (0,router.useRouter)();
    const activeUrl = (0,react.useMemo)(()=>{
        if (route.isFallback) return "";
        return route.query.slug && Array.isArray(route.query.slug) ? "/".concat(route.query.slug.join("/")) : route.query.slug;
    }, [
        route
    ]);
    const getAnchorTarget = (href)=>{
        if (!href) return "_blank";
        if (href.startsWith("http://") || href.startsWith("https://")) {
            let domain = new URL(href);
            if ( true && domain.origin === window.location.origin) {
                return "_self";
            }
            return "_blank";
        }
        return "_self";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (business_hub_menu_item_module_default()).dropdownContainer,
        style: popperStyles.popper,
        ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
        children: items === null || items === void 0 ? void 0 : items.map((item)=>{
            const href = (0,LangHelper/* replaceOrAddLocale */.yM)(item.url || "", locale);
            const target = getAnchorTarget(href);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                className: classnames_default()((business_hub_menu_item_module_default()).menuItem, (business_hub_menu_item_module_default()).child, {
                    [(business_hub_menu_item_module_default()).active]: activeUrl === href
                }),
                target: target,
                "aria-label": item.name,
                children: item.name
            }, item.key);
        })
    });
};
/* harmony default export */ var business_hub_menu_dropdown = (/*#__PURE__*/(0,react.forwardRef)(BusinessHubMenuDropdown));

;// CONCATENATED MODULE: ./components/business-hub-navigation/business-hub-menu-item.tsx









const BusinessHubMenuItem = (props)=>{
    const { name , url , locale: itemLocale , childrenItems  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const route = (0,router.useRouter)();
    const isActive = (0,react.useMemo)(()=>{
        if (route.isFallback) return false;
        const itemUrl = (0,LangHelper/* replaceOrAddLocale */.yM)(url || "", locale);
        const pageSlug = route.query.slug && Array.isArray(route.query.slug) ? "/".concat(route.query.slug.join("/")) : route.query.slug;
        return pageSlug === itemUrl;
    }, [
        route
    ]);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        15
                    ]
                }
            },
            {
                name: "eventListeners",
                enabled: false
            }
        ],
        placement: "bottom-start",
        strategy: "absolute"
    });
    if ((itemLocale === null || itemLocale === void 0 ? void 0 : itemLocale.length) && !itemLocale.includes(locale)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: setReferenceElement,
        className: (business_hub_menu_item_module_default()).container,
        children: [
            url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(url || "", locale),
                className: classnames_default()((business_hub_menu_item_module_default()).menuItem, {
                    [(business_hub_menu_item_module_default()).active]: isActive
                }),
                "aria-label": name,
                children: name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_menu_item_module_default()).menuItem,
                children: name
            }),
            childrenItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_menu_dropdown, {
                ref: setPopperElement,
                items: childrenItems.filter((child)=>{
                    if (!child.locale) return true;
                    return child.locale.includes(locale);
                }),
                popperStyles: popperStyles,
                attributes: attributes
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/business-hub-navigation/business-hub-top-navigation-menu-item.module.scss
var business_hub_top_navigation_menu_item_module = __webpack_require__(13303);
var business_hub_top_navigation_menu_item_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_top_navigation_menu_item_module);
;// CONCATENATED MODULE: ./components/business-hub-navigation/business-hub-top-navigation-menu-item.tsx




const BusinessHubTopNavigationMenuItem = (props)=>{
    const { businessHubMenuData =[]  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_top_navigation_menu_item_module_default()).container,
        children: businessHubMenuData.map((param)=>/*#__PURE__*/ {
            let { key , ...data } = param;
            return (0,jsx_runtime.jsx)(BusinessHubMenuItem, {
                ...data
            }, key);
        })
    });
};

// EXTERNAL MODULE: ./components/business-hub-navigation/business-hub-top-navigation.module.scss
var business_hub_top_navigation_module = __webpack_require__(86279);
var business_hub_top_navigation_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_top_navigation_module);
;// CONCATENATED MODULE: ./components/business-hub-navigation/business-hub-top-navigation.tsx










const BusinessHubTopNavigation = (props)=>{
    const { signupLink , page  } = props;
    const [isMobileMenuActive, setIsMobileMenuActive] = (0,react.useState)(false);
    const [needCloseMobileMenu, setNeedCloseMobileMenu] = (0,react.useState)(false);
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const [scrollY, setScrollY] = (0,react.useState)(0);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    (0,react.useEffect)(()=>{
        if (width < 1200) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        if (isMobile) {
            if (needCloseMobileMenu) {
                setNeedCloseMobileMenu(false);
                setIsMobileMenuActive(false);
            }
        } else {
            setNeedCloseMobileMenu(true);
            if (isMobileMenuActive) {
                setIsMobileMenuActive(false);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMobile
    ]);
    (0,react.useEffect)(()=>{
        const body = document.body;
        if (!body) {
            return;
        }
        if (isMobileMenuActive) {
            body.classList.add("lock-scroll");
        } else {
            body.classList.remove("lock-scroll");
        }
    }, [
        isMobileMenuActive
    ]);
    (0,react.useEffect)(()=>{
        document.addEventListener("scroll", onScroll);
        onScroll();
        return ()=>{
            document.removeEventListener("scroll", onScroll);
        };
    }, []);
    const onScroll = (0,react.useCallback)(()=>{
        setScrollY(window.scrollY);
    }, []);
    const handleClickToggleMenu = ()=>{
        setIsMobileMenuActive((oldState)=>!oldState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_top_navigation_module_default()).container,
        style: {
            "--bh-scroll-y": "".concat(scrollY, "px")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_top_navigation_module_default()).box,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,LangHelper/* replaceOrAddLocale */.yM)("/business", locale),
                    className: (business_hub_top_navigation_module_default()).logo,
                    "aria-label": "Home",
                    children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "32",
                        height: "30",
                        viewBox: "0 0 32 30",
                        fill: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M28.9676 6.63199L24.6358 4.11382L20.2413 1.5575C17.3367 -0.133998 13.706 1.98991 13.706 5.39834V5.97065C13.706 6.2886 13.8688 6.58112 14.1442 6.73373L16.1849 7.91651C16.7483 8.24718 17.4494 7.82748 17.4494 7.16615V5.80532C17.4494 5.13126 18.1631 4.71157 18.739 5.04224L22.7453 7.38235L26.7391 9.70975C27.315 10.0404 27.315 10.8925 26.7391 11.2232L22.7453 13.5506L18.739 15.8907C18.1631 16.2214 17.4494 15.8017 17.4494 15.1276V14.4536C17.4494 11.0451 13.8187 8.90851 10.9141 10.6127L6.51966 13.1691L2.18783 15.6872C-0.729276 17.3914 -0.729276 21.6774 2.18783 23.3816L6.51966 25.8998L10.9141 28.4561C13.8187 30.1476 17.4494 28.0237 17.4494 24.6153V24.043C17.4494 23.725 17.2867 23.4325 17.0112 23.2799L14.9705 22.0971C14.4071 21.7664 13.706 22.1861 13.706 22.8475V24.2083C13.706 24.8824 12.9924 25.302 12.4165 24.9714L8.41016 22.6313L4.41635 20.3039C3.84044 19.9732 3.84044 19.1211 4.41635 18.7904L8.41016 16.463L12.4165 14.1229C12.9924 13.7922 13.706 14.2119 13.706 14.886V15.56C13.706 18.9685 17.3367 21.1051 20.2413 19.4009L24.6358 16.8446L28.9676 14.3264C31.8847 12.6095 31.8847 8.3362 28.9676 6.63199Z",
                            fill: "black"
                        })
                    }) : locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.LogoClearpay */.T.LogoClearpay
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.AfterPay */.T.AfterPay
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((business_hub_top_navigation_module_default()).menuBox),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((business_hub_top_navigation_module_default()).menuItems, {
                                [(business_hub_top_navigation_module_default()).active]: isMobileMenuActive
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubTopNavigationMenuItem, {})
                        }),
                        [
                            LangHelper/* Locale.Australia */.go.Australia,
                            LangHelper/* Locale.NewZealand */.go.NewZealand
                        ].includes(locale) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            link: locale === LangHelper/* Locale.NewZealand */.go.NewZealand ? "https://hub.afterpay.com/nz" : "https://hub.afterpay.com/au",
                            target: "_blank",
                            className: classnames_default()((business_hub_top_navigation_module_default()).signup, (business_hub_top_navigation_module_default()).hoverBondiMint),
                            buttonText: isMobile ? "Login" : "Business login",
                            autoMargin: false,
                            color: "black"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            link: signupLink,
                            target: "_blank",
                            className: (business_hub_top_navigation_module_default()).signup,
                            buttonText: isMobile ? "Sign-up" : "Business sign-up",
                            autoMargin: false
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((business_hub_top_navigation_module_default()).hamburger, {
                        [(business_hub_top_navigation_module_default()).active]: isMobileMenuActive
                    }),
                    onClick: ()=>handleClickToggleMenu(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_top_navigation_module_default()).iconMenu,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/layouts/business-hub-layout.tsx









const BusinessHubLayout = (props)=>{
    const { page , children  } = props;
    const { footerItems , theme , footnotes , hideFooter , hideNav , showContactUsForm , showSayHello , showReadyToGrow  } = (page === null || page === void 0 ? void 0 : page.data) || {};
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const isANZ = locale === LangHelper/* Locale.Australia */.go.Australia || locale === LangHelper/* Locale.NewZealand */.go.NewZealand;
    const localeName = (0,react.useMemo)(()=>{
        switch(locale){
            case LangHelper/* Locale.Australia */.go.Australia:
            case LangHelper/* Locale.NewZealand */.go.NewZealand:
                return "Australia";
            case LangHelper/* Locale.USA */.go.USA:
            case LangHelper/* Locale.CanadaEnglish */.go.CanadaEnglish:
                return "United States";
            case LangHelper/* Locale.GreatBritain */.go.GreatBritain:
                return "United Kingdom";
            default:
                return null;
        }
    }, [
        locale
    ]);
    const copyright = (0,react.useMemo)(()=>{
        switch(locale){
            case LangHelper/* Locale.Australia */.go.Australia:
            case LangHelper/* Locale.NewZealand */.go.NewZealand:
                return "\xa9 2024 Afterpay Australia Pty Ltd.";
            case LangHelper/* Locale.USA */.go.USA:
            case LangHelper/* Locale.CanadaEnglish */.go.CanadaEnglish:
                return "\xa9 2024 Afterpay";
            case LangHelper/* Locale.GreatBritain */.go.GreatBritain:
                return "\xa9 2024 Clearpay";
            default:
                return null;
        }
    }, [
        locale
    ]);
    const disclaimers = (0,react.useMemo)(()=>{
        switch(locale){
            case LangHelper/* Locale.Australia */.go.Australia:
            case LangHelper/* Locale.NewZealand */.go.NewZealand:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Afterpay acknowledges the Australian Aboriginal and Torres Strait Islander peoples as the traditional custodians of the land, sea and waters where we live, meet and work. We pay our respects to their Elders past and present. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Always was, always will be, Aboriginal Land."
                        })
                    ]
                });
            case LangHelper/* Locale.GreatBritain */.go.GreatBritain:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Clearpay lends you a fixed amount of credit so you can pay for your purchase over 4 instalments, due every 2 weeks. Ensure you can make repayments on time. You must be 18+ and a permanent UK resident (excl Channel Islands). Clearpay charges a \xa36 late fee for each late instalment and a further \xa36 if it’s still unpaid 7 days later. Late fees are capped at \xa36 for orders under \xa324 and the lower of \xa324 or 25% of the order value for orders over \xa324. Missed payments may affect your ability to use Clearpay in the future and your details may be passed onto a debt collection agency working on Clearpay's behalf. Clearpay is credit that is not regulated by the Financial Conduct Authority. T&Cs and other eligibility criteria apply at",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.clearpay.co.uk/en-GB/terms-of-service",
                            target: "_blank",
                            children: "https://www.clearpay.co.uk/en-GB/terms-of-service"
                        }),
                        "."
                    ]
                });
            default:
                return null;
        }
    }, [
        locale
    ]);
    const onboardingLink = (0,react.useMemo)(()=>{
        switch(locale){
            case LangHelper/* Locale.GreatBritain */.go.GreatBritain:
                return "https://hub.clearpay.co.uk/signup";
            case LangHelper/* Locale.USA */.go.USA:
                return "https://hub.us.afterpay.com/signup";
            case LangHelper/* Locale.CanadaEnglish */.go.CanadaEnglish:
            case LangHelper/* Locale.CanadaFrench */.go.CanadaFrench:
                return "https://hub.us.afterpay.com/signup?country=ca";
            case LangHelper/* Locale.Australia */.go.Australia:
                return "https://hub.afterpay.com/signup?country=au";
            case LangHelper/* Locale.NewZealand */.go.NewZealand:
                return "https://hub.afterpay.com/signup?country=nz";
            default:
                return "https://hub.afterpay.com/signup";
        }
    }, [
        locale
    ]);
    const LocaleIcon = localeName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: generic_module.locale,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "19",
                height: "20",
                viewBox: "0 0 19 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.2222 1.02319V2.78424C13.7256 3.35398 15.7715 5.14095 16.7038 7.48034C15.055 6.63436 12.7156 6.15092 10.3589 6.04733V1.71383C10.3589 1.71383 10.3589 1.71382 10.3589 1.70519V0.89379C10.0741 0.867893 9.78918 0.850586 9.49568 0.850586C4.25579 0.850586 0 5.10638 0 10.3463C0 14.9905 3.35802 18.8579 7.76919 19.678V17.9169C5.26579 17.3472 3.21989 15.5602 2.28759 13.2208C3.93639 14.0668 6.28442 14.5589 8.64108 14.6538V18.0723V19.8074C8.92595 19.8333 9.21082 19.8506 9.50432 19.8506C14.7442 19.8506 19 15.5948 19 10.3549C19 5.71066 15.642 1.84327 11.2308 1.02319H11.2222ZM17.2649 10.3549C17.2649 11.3476 14.6061 12.7547 10.3589 12.9274V7.78246C14.5974 7.95511 17.2649 9.36218 17.2649 10.3549ZM8.63244 2.63756V6.05597C6.27578 6.15093 3.92777 6.64301 2.27898 7.48898C3.3235 4.87336 5.74057 2.95696 8.63244 2.63756ZM1.72649 10.3549C1.72649 9.36218 4.39391 7.95511 8.63244 7.78246V12.9274C4.38528 12.7547 1.72649 11.3476 1.72649 10.3549ZM10.3589 18.0723V14.6538C12.7156 14.5589 15.055 14.0668 16.7038 13.2208C15.6592 15.8278 13.2508 17.7442 10.3589 18.0723Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: localeName
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: generic_module["business-hub-layout"],
        children: [
            hideNav ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubTopNavigation, {
                page: page,
                signupLink: onboardingLink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(generic_module.content, generic_module["--no-top-padding"]),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: generic_module.footer,
                children: [
                    hideFooter ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubFooter, {
                        theme: theme,
                        showContactUsForm: showContactUsForm,
                        showSayHello: showSayHello,
                        showReadyToGrow: showReadyToGrow,
                        footerLink: onboardingLink,
                        page: page
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_footnotes/* default */.Z, {
                        content: footnotes
                    }),
                    LocaleIcon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(generic_module["disclaimers-box"], generic_module.mobile),
                        children: [
                            LocaleIcon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "34",
                                height: "30",
                                viewBox: "0 0 34 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M30.8531 5.94546L26.2373 3.30405L21.5548 0.62262C18.4598 -1.15166 14.5911 1.0762 14.5911 4.65144V5.25175C14.5911 5.58526 14.7645 5.8921 15.058 6.05218L17.2325 7.29284C17.8328 7.6397 18.5799 7.19946 18.5799 6.50576V5.07833C18.5799 4.37129 19.3403 3.93105 19.954 4.2779L24.2229 6.73254L28.4785 9.17385C29.0922 9.5207 29.0922 10.4145 28.4785 10.7614L24.2229 13.2027L19.954 15.6573C19.3403 16.0042 18.5799 15.5639 18.5799 14.8569V14.1498C18.5799 10.5746 14.7112 8.3334 11.6162 10.121L6.94704 12.8158L2.33124 15.4572C-0.777081 17.2448 -0.777081 21.7405 2.33124 23.5282L6.94704 26.1696L11.6295 28.851C14.7245 30.6253 18.5933 28.3974 18.5933 24.8222V24.2219C18.5933 23.8884 18.4198 23.5815 18.1263 23.4214L15.9518 22.1808C15.3515 21.8339 14.6045 22.2742 14.6045 22.9679V24.3953C14.6045 25.1023 13.8441 25.5426 13.2304 25.1957L8.96145 22.7411L4.70584 20.2998C4.09218 19.9529 4.09218 19.0591 4.70584 18.7123L8.96145 16.271L13.2304 13.8163C13.8441 13.4695 14.6045 13.9097 14.6045 14.6168V15.3238C14.6045 18.899 18.4732 21.1402 21.5682 19.3526L26.2507 16.6712L30.8665 14.0298C33.9614 12.2288 33.9614 7.73308 30.8531 5.94546Z",
                                    fill: "black"
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: localeName ? generic_module["footer-nav"] : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_footer/* default */.Z, {
                            theme: "white",
                            hideLogo: true,
                            footerData: footerItems,
                            isB2bAnz: isANZ
                        })
                    }),
                    localeName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: generic_module["disclaimers-box"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: generic_module.desktop,
                                children: LocaleIcon
                            }),
                            copyright ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: generic_module.copyright,
                                children: copyright
                            }) : null,
                            disclaimers ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: generic_module.disclaimers,
                                children: disclaimers
                            }) : null
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_layout = (BusinessHubLayout);


/***/ }),

/***/ 11170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ NotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _business_button_business_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52955);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39163);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77868);
/* harmony import */ var _layouts_business_hub_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53963);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22135);
/* harmony import */ var _layouts_b2b_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78506);
/* harmony import */ var _business_button_business_button_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79892);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48771);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_9__);











const NotFound = (param)=>{
    let { locale  } = param;
    const content = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    title: "Not found",
                    description: ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().background),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().imageDesktop),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                    src: locale === _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA ? "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F3f0f5343515a40c8882e63c512f67c17" : "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F004065bd99cd421bbdc17dc01367d887",
                                    alt: "",
                                    loading: "lazy",
                                    fill: true,
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().overlay),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                                    children: "Page not found."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                    children: "Let’s get back you back on the right path."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().cta),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_button_business_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        buttonText: "Discover Afterpay for Business",
                                        autoMargin: false,
                                        link: (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .localifyLink */ .Bj)("/".concat(locale, "/business"), locale),
                                        color: locale === _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA ? _business_button_business_button_constants__WEBPACK_IMPORTED_MODULE_8__/* .COLORS.WHITE */ .DM.WHITE : _business_button_business_button_constants__WEBPACK_IMPORTED_MODULE_8__/* .COLORS.MINT */ .DM.MINT
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_10___default().imageMobile),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                        src: locale === _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA ? "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F4c6ab5b8055a4d488821c76d5aa14efd" : "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fe38c87e5cfcf4a908ff72b4419463308",
                                        alt: "",
                                        loading: "lazy",
                                        fill: true,
                                        style: {
                                            objectFit: "cover",
                                            objectPosition: "center"
                                        },
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }, [
        locale
    ]);
    if (locale === _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_b2b_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            page: {
                data: {
                    hideFooter: true
                }
            },
            model: "business-hub",
            children: content
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_business_hub_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        page: {
            data: {
                hideFooter: true
            }
        },
        children: content
    });
};


/***/ }),

/***/ 20548:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-footer-bottom_container__SWWeO","background":"business-hub-footer-bottom_background__AHoOc","title":"business-hub-footer-bottom_title__vmDfH","desktop":"business-hub-footer-bottom_desktop__1ZyjI","mobile":"business-hub-footer-bottom_mobile__UaR66","word":"business-hub-footer-bottom_word__8pFiN","button":"business-hub-footer-bottom_button__RhHN5","wobble-vertical":"business-hub-footer-bottom_wobble-vertical__0SjYk"};

/***/ }),

/***/ 63745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"business-hub-footer-contact-us_section__xsCTq","background":"business-hub-footer-contact-us_background__hVfW2","rounded":"business-hub-footer-contact-us_rounded__lv0WB","title":"business-hub-footer-contact-us_title__a6EqQ","sectionForm":"business-hub-footer-contact-us_sectionForm___Xmzo","sectionAfterSubmit":"business-hub-footer-contact-us_sectionAfterSubmit__LYawR"};

/***/ }),

/***/ 21302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-footer-top_container___ttoX","background":"business-hub-footer-top_background__umL5k","imageBox":"business-hub-footer-top_imageBox__Ef9_x","image":"business-hub-footer-top_image__01FNc","content":"business-hub-footer-top_content__SCCLV","left":"business-hub-footer-top_left__yBFT7","title":"business-hub-footer-top_title__F7wHk","desktopBr":"business-hub-footer-top_desktopBr__tivI1","mobileBr":"business-hub-footer-top_mobileBr__sFeT4","description":"business-hub-footer-top_description__hFcuk","button":"business-hub-footer-top_button__XK6bF","right":"business-hub-footer-top_right__OFu_y","rightBox":"business-hub-footer-top_rightBox__xNGD_","--light":"business-hub-footer-top_--light__WtplT"};

/***/ }),

/***/ 47790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-footer_container__VwjfL","top":"business-hub-footer_top__THPdg","background":"business-hub-footer_background__ez1G7"};

/***/ }),

/***/ 26401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-menu-item_container__YhE_F","dropdownContainer":"business-hub-menu-item_dropdownContainer__dWb3a","menuItem":"business-hub-menu-item_menuItem__0jM0R","child":"business-hub-menu-item_child__IJsJ5","active":"business-hub-menu-item_active__tLxJV"};

/***/ }),

/***/ 13303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-top-navigation-menu-item_container__YFu1R"};

/***/ }),

/***/ 86279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-top-navigation_container__EtcLo","box":"business-hub-top-navigation_box__RQnDa","logo":"business-hub-top-navigation_logo__WEZx_","menuItemsBg":"business-hub-top-navigation_menuItemsBg__QSKxZ","menuBox":"business-hub-top-navigation_menuBox__FW5Me","menuItems":"business-hub-top-navigation_menuItems__Facuu","active":"business-hub-top-navigation_active__hlUWw","signup":"business-hub-top-navigation_signup__I3arZ","hoverBondiMint":"business-hub-top-navigation_hoverBondiMint__Z2Hkk","hamburger":"business-hub-top-navigation_hamburger__ZoebV","iconMenu":"business-hub-top-navigation_iconMenu__L2J8J"};

/***/ }),

/***/ 39163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__pAuDF","background":"not-found_background___Kltr","imageDesktop":"not-found_imageDesktop__EQSg3","overlay":"not-found_overlay__oNUO1","title":"not-found_title__vxaaF","description":"not-found_description__ryPZM","imageMobile":"not-found_imageMobile__SKA3b"};

/***/ })

}]);